import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import type { ReactNode } from "react";

export function SortableAdHocItem({
  id,
  exerciseName,
  disabled,
  children,
}: {
  id: number;
  exerciseName: string;
  disabled?: boolean;
  children: ReactNode;
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.7 : 1,
    zIndex: isDragging ? 10 : "auto",
  } as const;

  return (
    <div ref={setNodeRef} style={style} className="relative">
      <button
        type="button"
        aria-label={`reorder ${exerciseName}`}
        className="absolute left-2 top-2 cursor-grab touch-none rounded-md border border-slate-700 px-2 py-1 text-xs text-slate-400 hover:bg-slate-800 active:cursor-grabbing disabled:opacity-30"
        disabled={disabled}
        {...attributes}
        {...listeners}
      >
        ⠿
      </button>
      <div className="pl-10">{children}</div>
    </div>
  );
}
